module.exports = __webpack_public_path__ + "static/assets/c497375f2d5d99795efe8589bb6cad3e.svg";